import React from 'react';
import { CalendarOutlined } from '@ant-design/icons';
import RangeDatePicker from '../../form/basicFields/RangeDatePicker/RangeDatePicker';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

// https://ant.design/components/table/#components-table-demo-custom-filter-panel
export const useDataGridDateRangeFilter = (dataIndex) => {
  return {
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ width: 300 }}>
        <RangeDatePicker
          size="large"
          variant={false}
          value={selectedKeys[0]}
          onChange={(dates) => {
            // Picker was cleared.
            if (!dates) {
              setSelectedKeys([]);
              confirm({ closeDropdown: false });
              return;
            }

            setSelectedKeys([dates]);
            confirm({ closeDropdown: false });
          }}
        />
      </div>
    ),
    filterIcon: (filtered) => (
      <CalendarOutlined
        style={{
          color: filtered ? '#1890ff' : undefined,
        }}
      />
    ),
    onFilter: ([startDate, endDate], record) => {
      if (!record[dataIndex]) {
        return false;
      }

      const date = dayjs(record[dataIndex]);
      // Ignore time and include current days.
      return date.isBetween(startDate, endDate, 'day', '[]');
    },
  };
};
